import { render } from "./sf-portal.vue?vue&type=template&id=7c9e91b8"
import script from "./sf-portal.vue?vue&type=script&lang=js"
export * from "./sf-portal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__